import { UNSPLASH_URL } from './constants';

export const isUnsplashImage = (imageUrl?: string): boolean => {
	if (!imageUrl) {
		return false;
	}
	return imageUrl?.includes(UNSPLASH_URL);
};
